import './EQControl.css'

function EQControl({ eq, onChange, deckLabel }) {
  const handleSliderChange = (band, value) => {
    onChange({
      ...eq,
      [band]: parseInt(value)
    })
  }

  const getEQLabel = (value) => {
    if (value === 0) return 'KILL'
    if (value === 50) return '0dB'
    const db = ((value - 50) * 0.24).toFixed(1)
    return `${db > 0 ? '+' : ''}${db}dB`
  }

  return (
    <div className="eq-control">
      <h5 className="eq-title">EQ Controls - Deck {deckLabel}</h5>

      <div className="eq-bands">
        <div className="eq-band">
          <label className="eq-label">
            HIGH
            <span className="eq-value">{getEQLabel(eq.high)}</span>
          </label>
          <input
            type="range"
            min="0"
            max="100"
            value={eq.high}
            onChange={(e) => handleSliderChange('high', e.target.value)}
            className="eq-slider"
          />
        </div>

        <div className="eq-band">
          <label className="eq-label">
            MID
            <span className="eq-value">{getEQLabel(eq.mid)}</span>
          </label>
          <input
            type="range"
            min="0"
            max="100"
            value={eq.mid}
            onChange={(e) => handleSliderChange('mid', e.target.value)}
            className="eq-slider"
          />
        </div>

        <div className="eq-band">
          <label className="eq-label">
            LOW
            <span className="eq-value low">{getEQLabel(eq.low)}</span>
          </label>
          <input
            type="range"
            min="0"
            max="100"
            value={eq.low}
            onChange={(e) => handleSliderChange('low', e.target.value)}
            className="eq-slider low"
          />
          {eq.low === 0 && (
            <div className="kill-indicator">BASS KILLED</div>
          )}
        </div>
      </div>

      <button
        className="reset-eq-btn"
        onClick={() => onChange({ low: 50, mid: 50, high: 50 })}
      >
        Reset EQ
      </button>
    </div>
  )
}

export default EQControl
